@if (view(); as currentView) {
  @if (subtaskFormArray.at(subtaskIndex)) {
    <div class="subtask-edit-container oph-scroll-bar" [style.height]="currentView !== 'subtask' ? '100%' : '90%'">
      @if (currentView === 'subtask') {
        <subtask-edit
          #subtaskEdit
          [controls]="$any(subtaskFormArray.at(subtaskIndex))"
          [taskDialog]="true"
          [fromTemplate]="fromTemplate"
          [editorContainerMaxHeight]="editorContainerMaxHeight"
          (imageAdded)="onImageAdded($event)"
          (connectTrackerClicked)="onConnectTrackerClicked($any($event))"
          (newTracker)="view.set('newTracker')"
        ></subtask-edit>
      }
      @if (currentView === 'tracker' || currentView === 'metric') {
        <div class="metric-button-container">
          <oph-back-button (buttonClick)="view.set('subtask')"></oph-back-button>
        </div>
        @if (
          {
            selectedTracker: selectedTracker$ | async,
            filteredMetrics: filteredMetrics$ | async,
            trackersWithMetrics: trackersWithMetrics$ | async
          };
          as state
        ) {
          @if (currentView === 'metric') {
            <div class="metric-view-header">
              <mat-icon class="tracker-icon-large" svgIcon="tracker"></mat-icon>
              <span class="tracker-name-large">{{ state.selectedTracker?.name }}</span>
            </div>
          } @else {
            <h1 class="select-tracker-heading">Select a tracker</h1>
          }

          <!-- ====================================== -->
          <!-- Select a metric -->
          <!-- ====================================== -->
          @if (currentView === 'metric') {
            <div class="metric-content-wrapper">
              @if (state.filteredMetrics?.length) {
                <div class="metrics-container" oph-scroll-bar>
                  <oph-checkbox
                    class="select-all-checkbox"
                    [checked]="allMetricsChecked()"
                    [textStyle]="{
                      color: 'var(--Ophanim-Final-grey-med, #7A746F)',
                      'font-family': 'Asap',
                      'font-size': '14px',
                      'font-style': 'italic',
                      'font-weight': '400',
                      'line-height': '24px'
                    }"
                    text="Select all"
                    textOrientation="right"
                    color="green"
                    (click)="$event.stopPropagation()"
                    (valueChange)="onSelectAll()"
                  >
                  </oph-checkbox>
                  <div cdkDropList (cdkDropListDropped)="onMetricsDrop($event)">
                    @for (metric of state.filteredMetrics; track metric._id) {
                      <div class="metric-item" [cdkDragDisabled]="!metricsCheckedMap()[metric._id]" cdkDrag>
                        <oph-icon
                          class="drag-handle"
                          name="3-line-handle"
                          [size]="19"
                          [class.disabled]="!metricsCheckedMap()[metric._id]"
                          cdkDragHandle
                        ></oph-icon>
                        <oph-checkbox
                          [checked]="metricsCheckedMap()[metric._id]"
                          [text]="metric.name"
                          [textStyle]="{
                            color: 'var(--off-black)',
                            fontSize: '16px',
                            fontWeight: '500',
                            fontStyle: 'normal',
                            lineHeight: '24px',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden'
                          }"
                          textOrientation="right"
                          color="green"
                          [width]="25"
                          [gap]="15"
                          (valueChange)="onMetricCheckChange({metricId: metric._id, checked: $event})"
                        ></oph-checkbox>
                        <!-- <span class="metric-name">{{ metric.name }}</span> -->
                        <oph-checkbox
                          class="read-only-checkbox"
                          [checked]="metricsReadOnlyMap()[metric._id]"
                          [textStyle]="{
                            color: 'var(--grey-med)',
                            fontSize: '14px',
                            fontStyle: 'italic',
                            fontWeight: '400',
                            lineHeight: '24px',
                            whiteSpace: 'nowrap'
                          }"
                          text="Read only"
                          textOrientation="right"
                          color="green"
                          [minWidth]="100"
                          (click)="$event.stopPropagation()"
                          (valueChange)="onMetricReadOnlyChange({metricId: metric._id, readOnly: $event})"
                        >
                        </oph-checkbox>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="empty">
                  <span class="metric-name">This tracker has no metrics</span>
                </div>
              }
              <div class="new-metric-button-container">
                <oph-button
                  color="gray"
                  class="add-metric-button"
                  appearance="outline"
                  [style]="{width: '157px', height: '30px', fontSize: '14px', borderRadius: '6px'}"
                  (buttonClick)="onNewMetricClicked()"
                >
                  <mat-icon svgIcon="plus"></mat-icon>
                  <span>New Metric</span>
                </oph-button>
              </div>
            </div>
          } @else {
            <!-- ====================================== -->
            <!-- Select a tracker -->
            <!-- ====================================== -->
            @if (state.trackersWithMetrics?.length) {
              <div class="trackers-container" oph-scroll-bar>
                @for (tracker of state.trackersWithMetrics; track tracker._id) {
                  <div class="tracker-item" (click)="onTracker(tracker)">
                    <mat-icon class="tracker-icon" svgIcon="tracker"></mat-icon>
                    <span class="tracker-name">{{ tracker.name }}</span>
                  </div>
                }
              </div>
            } @else {
              <div class="empty">
                <span class="metric-name">This project has no trackers with metrics</span>
              </div>
            }
          }
        }
      }
      @if (currentView === 'newTracker') {
        <new-tracker-in-dialog
          [projectId]="projectId"
          (closeNewTrackerInDialog)="onCloseNewTrackerInDialog($event?.metricIds, $event?.trackerId)"
        ></new-tracker-in-dialog>
      }
      @if (currentView === 'newMetric') {
        <projects-task-subtask-new-metric
          [trackerId]="subtaskFormArray.at(subtaskIndex).value.trackerId"
          (back)="onNewMetricBack()"
          (metricAdded)="onMetricAdded($event)"
        ></projects-task-subtask-new-metric>
      }
    </div>
  }

  <!-- ----------------------------FOOTERS-------------------------------- -->

  @if (currentView === 'subtask' && !editingTask) {
    <projects-task-subtask-button-footer
      [disabled]="!subtaskFormArray.at(subtaskIndex).value.title"
      (back)="onBack()"
      (newSubtask)="newSubtask.emit()"
      (finish)="finish.emit()"
    ></projects-task-subtask-button-footer>
  }

  @if (editingTask && currentView === 'subtask') {
    <div class="metric-button-container">
      <oph-button appearance="outline" color="gray" (buttonClick)="onEditingTaskBack()">Back</oph-button>
      <oph-button
        color="green"
        (buttonClick)="onEditingTaskNext()"
        [disabled]="!subtaskFormArray.at(subtaskIndex).value.title"
        >Next</oph-button
      >
    </div>
  }
}
